import { createEffect } from 'effector'

export const historyReplaceStateFx = createEffect((url: string) => {
  window.history.replaceState(window.history.state, '', url)
})
